import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import withInstagramFeed from 'origen-react-instagram-feed';
import compose from 'recompose/compose';
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import styles from './InstaFeed.module.scss';
import { BRAND } from '../../constants/brand';
import { Hidden } from '../index';
import { useMeasure } from '../hoc';

export type InstaFeedStatus = 'completed' | 'loading' | 'failed';

export interface InstaFeedProps {
  className?: string;
  media?: Array<{
    displayImage: string;
    id?: string;
    postLink?: string;
    accessibilityCaption?: string;
  }>;
  account: string;
  status: InstaFeedStatus;
}

const InstaFeed: FunctionComponent<InstaFeedProps> = ({
  media,
  account,
  status,
  className,
}) => {
  if (status === 'failed') {
    return null;
  }

  const instaFeedClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-insta-feed`,
    className,
  );

  let bind;
  let width;
  let visibleSlides = 3;

  if (media && status === 'completed') {
    // @ts-ignore
    [bind, { width }] = useMeasure();
    switch (true) {
      case width <= 768:
        visibleSlides = 3;
        break;
      case width <= 1280 && width > 768:
        visibleSlides = 5;
        break;
      default:
        visibleSlides = 7;
    }
  }

  const classNameTrayWrap = classNames({
    [styles.trayWrap]: true,
    [styles[`trayWrap${visibleSlides}`]]: true,
  });

  return (
    <div className={instaFeedClass}>
      {media && status === 'completed' && (
        <CarouselProvider
          naturalSlideWidth={20}
          naturalSlideHeight={20}
          infinite
          totalSlides={media.length}
          visibleSlides={visibleSlides}
          dragEnabled={false}
          touchEnabled={false}
          className={styles.sliderContainer}
        >
          <div {...bind}>
            <Slider classNameTrayWrap={classNameTrayWrap}>
              {media.map(
                (
                  { displayImage, id, postLink, accessibilityCaption },
                  index,
                ) => (
                  <Slide
                    index={index}
                    key={id || displayImage}
                    className={styles.slide}
                    innerClassName={styles.slideInner}
                  >
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={postLink || `https://www.instagram.com/${account}/`}
                    >
                      <img
                        src={displayImage}
                        alt={accessibilityCaption || 'Instagram picture'}
                      />
                    </a>
                  </Slide>
                ),
              )}
            </Slider>

            <ButtonBack className={styles.previousButton}>
              <Hidden>Previous</Hidden>
            </ButtonBack>
            <ButtonNext className={styles.nextButton}>
              <Hidden>Next</Hidden>
            </ButtonNext>
          </div>
        </CarouselProvider>
      )}
      {status === 'loading' && <p>loading...</p>}
    </div>
  );
};

export { InstaFeed };

export default compose(withInstagramFeed)(InstaFeed);
